var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExclamationIcon = function SvgExclamationIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0835 12.7497H10.9168V14.583H9.0835V12.7497ZM9.0835 5.41634H10.9168V10.9163H9.0835V5.41634ZM9.991 0.833008C4.931 0.833008 0.833496 4.93967 0.833496 9.99967C0.833496 15.0597 4.931 19.1663 9.991 19.1663C15.0602 19.1663 19.1668 15.0597 19.1668 9.99967C19.1668 4.93967 15.0602 0.833008 9.991 0.833008ZM10.0002 17.333C5.9485 17.333 2.66683 14.0513 2.66683 9.99967C2.66683 5.94801 5.9485 2.66634 10.0002 2.66634C14.0518 2.66634 17.3335 5.94801 17.3335 9.99967C17.3335 14.0513 14.0518 17.333 10.0002 17.333Z",
    fill: "#F44336"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "exclamation-icon.e61ab72e92a1ceff7131d451b1658039.svg";